import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  Typography
} from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import getTimeZoneList from './input';
import { DispatchContext, StateContext } from '../../App';

const UserSettings = (props: any) => {
  const dispatch = useContext(DispatchContext);
  const state = useContext(StateContext);

  const [timeZone, setTimeZone] = React.useState<any>(
    props?.data?.configurationSettings?.data?.[0]?.configuration?.timeZone || 'UTC'
  );

  const [requestResponse, setRequestResponse] = React.useState<any>(
    props?.data?.configurationSettings?.data?.[0]?.configuration?.requestResponse || 'code'
  );

  const [eventType, setEventType] = React.useState<any>(
    props?.data?.configurationSettings?.data?.[0]?.configuration?.eventType || 'all'
  );

  useEffect(() => {
    const tz = props?.data?.configurationSettings?.data?.[0]?.configuration?.timeZone;
    const prevTz = state?.userPreferences?.timeZone || 'UTC';
    if (tz && tz !== prevTz) {
      setTimeZone(tz);
      dispatch({
        type: 'userPreferences',
        data: {
          timeZone: props?.data?.configurationSettings?.data?.[0]?.configuration?.timeZone
        }
      });
    }
    const requestValue = props?.data?.configurationSettings?.data?.[0]?.configuration?.requestResponse;
    const prevRequestValue = state?.userPreferences?.requestResponse || 'code';
    if (requestValue && requestValue !== prevRequestValue) {
      setRequestResponse(requestValue);
      dispatch({
        type: 'userPreferences',
        data: {
          requestResponse: props?.data?.configurationSettings?.data?.[0]?.configuration?.requestResponse
        }
      });
    }
    const eventTypeValue = props?.data?.configurationSettings?.data?.[0]?.configuration?.eventType;
    const prevEventType = state?.userPreferences?.requestResponse || 'all';
    if (eventTypeValue && eventTypeValue !== prevEventType) {
      setEventType(eventTypeValue);
      dispatch({
        type: 'userPreferences',
        data: {
          eventType: props?.data?.configurationSettings?.data?.[0]?.configuration?.eventType
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data]);

  const getMenuItems = () => {
    return getTimeZoneList.map((option: any) => (
      <MenuItem key={option.title} value={option.field}>
        {option.title}
      </MenuItem>
    ));
  };

  const selectTimeZone = (e: any) => {
    setTimeZone(e.target.value);
  };

  const selectRequestResponse = (e: any) => {
    setRequestResponse(e.target.value);
  };

  const selectEventType = (e: any) => {
    setEventType(e.target.value);
  };

  const handleSaveSettings = () => {
    const obj = {
      timeZone: timeZone,
      eventType: eventType,
      requestResponse: requestResponse
    };
    props.handleSaveSettings(obj);
  };

  const handleCancel = () => {
    setTimeZone(props?.data?.configurationSettings?.data?.[0]?.configuration?.timeZone || 'UTC');
    setRequestResponse(props?.data?.configurationSettings?.data?.[0]?.configuration?.requestResponse || 'view');
    setEventType(props?.data?.configurationSettings?.data?.[0]?.configuration?.eventType || 'all');
    props.handleCancel();
  };

  return (
    <Dialog open={props.settingsDialogOpen} aria-labelledby="customized-dialog-title" maxWidth="xs" fullWidth>
      <DialogTitle id="alert-dialog-title">User Settings</DialogTitle>
      <DialogContent dividers>
        <Grid container justify="space-between" spacing={1}>
          <Grid item xs={4}>
            <Typography>Time Zone</Typography>
          </Grid>
          <Grid item xs={5}>
            <Select id="timezone-select" data-id="timezone-select" value={timeZone} onChange={e => selectTimeZone(e)}>
              {getMenuItems()}
            </Select>
          </Grid>
          <Grid item xs={4}>
            <Typography>Request/Response</Typography>
          </Grid>
          <Grid item xs={5}>
            <Select
              label="Request/Response"
              id="Select-requestresponse-view"
              data-id="Select-requestresponse-view"
              // className={classes.textField}
              value={requestResponse}
              onChange={e => selectRequestResponse(e)}
            >
              <MenuItem value="code">Code</MenuItem>
              <MenuItem value="view">View</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={4}>
            <Typography>Default Event Type</Typography>
          </Grid>
          <Grid item xs={5}>
            <Select
              label="Default Event Type"
              id="Select-event-type"
              data-id="Select-event-type"
              value={eventType}
              onChange={e => selectEventType(e)}
            >
              <MenuItem value="errors">Errors</MenuItem>
              <MenuItem value="all">All</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button id="cancel-button" color="primary" variant="contained" onClick={handleCancel}>
          Cancel
        </Button>
        <Button id="save-button" color="primary" autoFocus variant="contained" onClick={handleSaveSettings}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserSettings;
